/* Morning Cult — Shopify Theme JS
   Handles: flavor data, hero picker, AJAX cart, cart drawer, survey popup,
   Klaviyo email capture, cart quantity updates.
   No framework dependencies.
*/

/* =====================================================================
   FLAVOR DATA (matches new design system)
   ===================================================================== */
window.MC_FLAVORS = [
  {
    id: "Original",
    full: "Original Matcha Latte",
    handle: "original-matcha-latte",
    tagline: "Notes of Matcha",
    note: "Clean · smooth · grounding.",
    desc: "The one that started it all. Pure ceremonial matcha with creamy oat milk.",
    can: "Original.png",
    mascot: "MatchaMaker.png",
    color: "#A8D858",
    tint:  "#EBF6D8",
    deep:  "#0E3D2A",
    calories: 70,
  },
  {
    id: "Blueberry",
    full: "Blueberry Matcha Latte",
    handle: "blueberry-matcha-latte",
    tagline: "Notes of Blueberry",
    note: "Bright · berry · smooth.",
    desc: "Blueberry and matcha — a surprisingly perfect pairing.",
    can: "Blueberry.png",
    mascot: "Thinker.png",
    color: "#5AB8D4",
    tint:  "#D5E5EC",
    deep:  "#087898",
    calories: 70,
  },
  {
    id: "Strawberry",
    full: "Strawberry Matcha Latte",
    handle: "strawberry-matcha-latte",
    tagline: "Notes of Strawberry",
    note: "Sweet · bright · summery.",
    desc: "Ripe strawberry layered over smooth matcha — summer in a can.",
    can: "Strawberry.png",
    mascot: "Artist.png",
    color: "#E87CAA",
    tint:  "#F7E4ED",
    deep:  "#C82868",
    calories: 70,
  },
  {
    id: "VanillaCinnamon",
    full: "Vanilla Cinnamon Matcha Latte",
    handle: "vanilla-cinnamon-matcha-latte",
    tagline: "Notes of Vanilla Cinnamon",
    note: "Warm · spiced · smooth.",
    desc: "A warm, cozy balance of vanilla bean and cinnamon over creamy matcha.",
    can: "VanillaCinnamon.png",
    mascot: "Hammock.png",
    color: "#C8A878",
    tint:  "#F5EFE0",
    deep:  "#882828",
    calories: 70,
  },
  {
    id: "Yuzu",
    full: "Yuzu Matcha Latte",
    handle: "yuzu-matcha-latte",
    tagline: "Notes of Citrus",
    note: "Bright · citrus · sharp.",
    desc: "Soft yuzu notes bring a refreshing contrast to smooth matcha.",
    can: "Yuzu.png",
    mascot: "LeafRobe.png",
    color: "#F0C850",
    tint:  "#FBEFD8",
    deep:  "#E89828",
    calories: 65,
  },
];

window.findFlavor = function(idOrHandle) {
  if (!idOrHandle) return window.MC_FLAVORS[0];
  const s = idOrHandle.toLowerCase().replace(/-/g, '');
  return window.MC_FLAVORS.find(f =>
    f.id.toLowerCase() === idOrHandle ||
    f.handle === idOrHandle ||
    f.id.toLowerCase().replace(/-/g,'') === s ||
    f.handle.replace(/-/g,'') === s
  ) || window.MC_FLAVORS[0];
};

/* Pack pricing */
window.MC_PACKS = [
  { id: "once",      label: "One Time",  sub: "Delivery",          price: 62, badge: null },
  { id: "weekly",    label: "Weekly",    sub: "Subscribe & Save",  price: 54, badge: "Most popular" },
  { id: "biweekly",  label: "Biweekly",  sub: "Subscribe & Save",  price: 54, badge: "Save 13%" },
];

/* =====================================================================
   HERO PICKER (home page flavor selector)
   ===================================================================== */
document.addEventListener('DOMContentLoaded', function() {
  initHeroPicker();
  initCartDrawer();
  initAddToCart();
  initProductPackPicker();
  initKlaviyoForms();
  initCartQty();
  initMobileNav();
});

function initHeroPicker() {
  const hero = document.querySelector('.hero');
  if (!hero) return;
  const picks = hero.querySelectorAll('.hero-pick');
  const canImg = hero.querySelector('.hero-can');
  const stageBg = hero.querySelector('.hero-stage-bg');
  const heroH   = hero.querySelector('.hero-h');

  picks.forEach((btn, i) => {
    btn.addEventListener('click', function() {
      picks.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      const flavor = window.MC_FLAVORS[i];
      if (!flavor) return;
      // Update background
      hero.style.backgroundColor = flavor.tint;
      if (stageBg) stageBg.style.backgroundColor = flavor.color;
      // Update can image
      if (canImg) {
        canImg.style.opacity = '0';
        canImg.style.transform = 'translateY(8px) scale(0.97)';
        setTimeout(() => {
          canImg.src = canImg.src.replace(/cans\/[^?]+/, 'cans/' + flavor.can);
          canImg.style.opacity = '1';
          canImg.style.transform = 'translateY(0) scale(1)';
        }, 180);
      }
      // Update shop CTA link
      const ctaLink = hero.querySelector('.hero-shop-btn');
      if (ctaLink) ctaLink.href = '/products/' + flavor.handle;
    });
  });
  // Activate first pick on load
  if (picks.length) picks[0].click();
}

/* =====================================================================
   CART DRAWER
   ===================================================================== */
function initCartDrawer() {
  const drawer  = document.getElementById('mc-cart-drawer');
  const overlay = document.getElementById('mc-cart-overlay');
  const closeBtn = document.getElementById('mc-cart-close');
  const cartBtn  = document.querySelector('.nav-cart');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('open');
    overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    refreshCartDrawer();
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('open');
    overlay.classList.remove('open');
    document.body.style.overflow = '';
  }
  if (cartBtn) cartBtn.addEventListener('click', function(e){ e.preventDefault(); openDrawer(); });
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (overlay)  overlay.addEventListener('click', closeDrawer);
  window.__mcOpenCart = openDrawer;
}

function refreshCartDrawer() {
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      renderCartDrawer(cart);
      updateCartCount(cart.item_count);
    });
}

function renderCartDrawer(cart) {
  const body = document.getElementById('mc-cart-body');
  if (!body) return;

  if (!cart.items || cart.items.length === 0) {
    body.innerHTML =
      '<div class="cart-drawer-empty">' +
        '<p>Nothing in the cart yet.</p>' +
        '<a class="btn dark" href="/collections/all" onclick="document.getElementById(\'mc-cart-overlay\').click()">Shop the five &rarr;</a>' +
      '</div>';
    return;
  }

  let rows = '';
  cart.items.forEach(item => {
    const flavor = window.findFlavor(item.handle || '');
    const bg = flavor ? flavor.tint : '#EBF6D8';
    const isSubscription = item.selling_plan_allocation != null;
    const eyebrow = isSubscription ? 'Subscription' : 'One-time';
    const sub = (item.variant_title || 'Case of 12') + ' · $' + (item.final_price / 100).toFixed(0) + '/case';
    rows += `
      <div class="cart-drawer-row" style="background:${bg}">
        <img class="cart-drawer-can" src="${item.image}" alt="">
        <div class="cart-drawer-meta">
          <div class="cart-drawer-eyebrow">${eyebrow}</div>
          <div class="cart-drawer-name">${item.product_title}</div>
          <div class="cart-drawer-sub">${sub}</div>
          <button class="cart-drawer-remove" data-key="${item.key}" type="button">Remove</button>
        </div>
        <div class="cart-drawer-qty">×${item.quantity}</div>
        <div class="cart-drawer-line-price">$${(item.final_line_price / 100).toFixed(0)}</div>
      </div>`;
  });

  body.innerHTML =
    '<div class="cart-drawer-body">' + rows + '</div>' +
    '<footer class="cart-drawer-foot">' +
      '<div class="cart-drawer-totals"><span>Subtotal</span>' +
        '<span class="cart-drawer-total-n">$' + (cart.total_price / 100).toFixed(0) + '</span></div>' +
      '<a class="btn dark cart-drawer-checkout" href="/checkout">Checkout &rarr;</a>' +
      '<a class="cart-drawer-viewcart" href="/cart" onclick="document.getElementById(\'mc-cart-overlay\').click()">View cart</a>' +
      '<button class="cart-drawer-keep" type="button" onclick="document.getElementById(\'mc-cart-overlay\').click()">Keep shopping</button>' +
    '</footer>';

  body.querySelectorAll('.cart-drawer-remove').forEach(btn => {
    btn.addEventListener('click', function() {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: btn.dataset.key, quantity: 0 })
      }).then(() => refreshCartDrawer());
    });
  });
}

function updateCartCount(n) {
  document.querySelectorAll('.nav-cart-count').forEach(el => {
    el.textContent = n;
    el.style.display = n > 0 ? 'flex' : 'none';
  });
}

/* =====================================================================
   ADD TO CART (product page)
   ===================================================================== */
function initAddToCart() {
  const form = document.getElementById('mc-product-form');
  if (!form) return;
  form.addEventListener('submit', function(e) {
    e.preventDefault();
    const btn  = form.querySelector('[type="submit"]');
    const data = new FormData(form);
    const body = JSON.stringify(Object.fromEntries(data));

    btn.disabled = true;
    btn.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body
    })
    .then(r => r.json())
    .then(() => {
      btn.textContent = '✓ Added!';
      btn.style.background = 'var(--mc-jade-700)';
      refreshCartDrawer();
      if (window.__mcOpenCart) setTimeout(window.__mcOpenCart, 400);
      setTimeout(() => {
        btn.disabled = false;
        btn.textContent = 'Add to cart';
        btn.style.background = '';
      }, 2200);
    })
    .catch(() => {
      btn.disabled = false;
      btn.textContent = 'Add to cart';
    });
  });
}

/* =====================================================================
   PRODUCT PACK PICKER
   ===================================================================== */
function initProductPackPicker() {
  const container = document.getElementById('mc-pack-picker');
  if (!container) return;

  container.querySelectorAll('.pb-pack').forEach(btn => {
    btn.addEventListener('click', function() {
      container.querySelectorAll('.pb-pack').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      // Update hidden selling_plan input
      const form = document.getElementById('mc-product-form');
      if (!form) return;
      const sellingPlanId = btn.dataset.sellingPlanId || '';
      let sp = form.querySelector('input[name="selling_plan"]');
      if (sellingPlanId) {
        if (!sp) {
          sp = document.createElement('input');
          sp.type = 'hidden';
          sp.name = 'selling_plan';
          form.appendChild(sp);
        }
        sp.value = sellingPlanId;
      } else {
        if (sp) sp.remove();
      }
      // Update price display
      const price = btn.dataset.price;
      const priceEl = document.getElementById('mc-price-display');
      if (priceEl && price) priceEl.textContent = '$' + price;
    });
  });
  // Default first active
  const first = container.querySelector('.pb-pack.active');
  if (!first) {
    const packs = container.querySelectorAll('.pb-pack');
    if (packs.length) packs[0].classList.add('active');
  }
}

/* =====================================================================
   CART QTY (cart page)
   ===================================================================== */
function initCartQty() {
  document.querySelectorAll('.cart-qty-btn').forEach(btn => {
    btn.addEventListener('click', function() {
      const key = btn.dataset.key;
      const delta = parseInt(btn.dataset.delta || '0');
      const qtyEl = btn.parentElement.querySelector('.cart-qty-val');
      const currentQty = parseInt(qtyEl ? qtyEl.textContent : '1');
      const newQty = Math.max(0, currentQty + delta);
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: newQty })
      }).then(() => window.location.reload());
    });
  });
}

/* =====================================================================
   KLAVIYO EMAIL CAPTURE
   ===================================================================== */
function initKlaviyoForms() {
  document.querySelectorAll('.mc-klaviyo-form').forEach(form => {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      const email = form.querySelector('input[type="email"]').value;
      if (!email) return;
      const btn = form.querySelector('button[type="submit"]');
      const listId = form.dataset.listId || 'MORNING_CULT_NEWSLETTER';

      if (window._learnq) {
        window._learnq.push(['identify', { '$email': email }]);
        window._learnq.push(['track', 'Newsletter Signup', { email, source: form.dataset.source || 'footer' }]);
      }

      btn.textContent = '✓ You\'re in!';
      btn.disabled = true;
      form.querySelector('input[type="email"]').value = '';
      setTimeout(() => {
        btn.textContent = 'Subscribe';
        btn.disabled = false;
      }, 3000);
    });
  });
}

/* =====================================================================
   MOBILE NAV TOGGLE
   ===================================================================== */
function initMobileNav() {
  const hamburger = document.getElementById('mc-hamburger');
  const mobileNav = document.getElementById('mc-mobile-nav');
  const mobileClose = document.getElementById('mc-mobile-close');

  if (!hamburger || !mobileNav) return;
  hamburger.addEventListener('click', () => {
    mobileNav.classList.toggle('open');
    document.body.style.overflow = mobileNav.classList.contains('open') ? 'hidden' : '';
  });
  if (mobileClose) mobileClose.addEventListener('click', () => {
    mobileNav.classList.remove('open');
    document.body.style.overflow = '';
  });
}

/* =====================================================================
   FLAVOR TAB SWITCHER (product-related, shop pages)
   ===================================================================== */
window.switchFlavor = function(handle) {
  window.location.href = '/products/' + handle;
};
